import React, { Component } from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import { TableComp } from 'sz-react-utils'
import moment from 'moment'
import {
  Modal,
  Card,
  Button, Tooltip,
  Select

} from 'antd'
import Request, { API_URL } from '../../../request'
import _ from 'lodash'
//import styles from './styles.less'
import { connect } from 'react-redux'
import { getUrlPushWrapper } from '../../../routes'
import { apiUrl } from '../../../settings'

const { Option } = Select

class Communication extends Component {

  constructor(props) {
    super(props)
    this.table = React.createRef()
    this.state = { visible: false, key: Date.now(), currentPage: 1 }

  }


  apiRequest = (params) => {
    if (params.page) {
      this.state.currentPage = params.page
    }
    let user = { ...JSON.parse(localStorage.getItem('user')) }
    if (user.userType === 'RO') {
      params.from = user.email

      return new Promise(async (resolve) => {

        let data = await Request.getAllCommunicationMails({
          ...params, regExFilters: ['to', 'from', 'subject']
        })

        this.setState({ count: data.total })
        resolve(data)
      })

    } else {
      return new Promise(async (resolve) => {

        let data = await Request.getAllCommunicationMails({
          ...params, regExFilters: ['to', 'from', 'subject']
        })

        this.setState({ count: data.total })
        resolve(data)
      })
    }


  }
  showModal = () => {
    this.setState({
      visible: true
    })
  }

  async componentDidMount() {

  }

  render() {
    const { submitting, dispatch } = this.props
    const { visible, singleMail, currentPage } = this.state


    const columns = [
      {
        title: 'S.No',
        dataIndex: 'sno',
        width: 50,
        key: 'sno',
        render: (value, item, index) => (currentPage - 1) * 10 + index + 1
      },
      {
        title: 'From',
        key: 'from',
        width: 150,
        dataIndex: 'from',
        searchTextName: 'from'


      },
      {
        title: 'To',
        dataIndex: 'to',
        width: 100,
        key: 'to',
        searchTextName: 'to'

      },


      {
        title: 'Subject',
        dataIndex: 'subject',
        width: 180,
        searchTextName: 'subject'

      },
      {
        title: 'Email',
        dataIndex: 'html',
        key: 'html',
        width: 80,
        render: (item, record) => (
          <React.Fragment>
            <Tooltip title={'View'}>
              <Button icon={'eye'}
                      onClick={() => {
                        this.setState({ singleMail: record }, () => {
                          this.showModal()
                        })

                      }}>View Mail</Button>
            </Tooltip>

          </React.Fragment>
        )
      },


      {
        title: 'Date',
        width: 120,
        key: 'date',
        dataIndex: 'date',
        sorter: true,
        render: (text, record) => {
          return (
            <div>
              {text ? moment(text).format('lll') : ''}
            </div>
          )
        }
      }

    ]


    return (
      <PageHeaderWrapper
        title={this.state.count ? `All Mails: ${this.state.count}` : `All Mails: 0`}>

        <Card bordered={true}>

          <TableComp ref={this.table}
                     columns={columns}
                     apiRequest={this.apiRequest}
                     pagination={{
                       ...this.state.pagination,
                       defaultPageSize: 10,
                       pageSizeOptions: ['10', '25', '50', '100'],
                       showSizeChanger: true,
                       ...this.props.pagination
                     }} />
        </Card>


        <Modal
          visible={visible}
          title="Email"
          onCancel={() => this.setState({ visible: false })}
          cancelButtonProps={{ style: { display: 'none' } }}
          okButtonProps={{ style: { display: 'none' } }}
          footer={false}
        >

          <div style={{
            // border: "1px solid #DAE0E2",
            margin: '5px',
            // backgroundColor: "#DAE0E2",
            width: '100%',
            padding: '3px'
          }} dangerouslySetInnerHTML={{ __html: singleMail && singleMail.html }}>
          </div>

          {singleMail && singleMail.subject.includes('Greetings') &&
          <div>Attachment : <a target={'_blank'} href={`${apiUrl}/Price catalouge.pdf`}>Click Here</a></div>}
        </Modal>

      </PageHeaderWrapper>)

  }
}


const mapStateToProps = ({ global }) => ({
  categories: global.categories,
  currentUser: global.currentUser
})
const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Communication)
